import { RightOutlined } from '@ant-design/icons';
import { Row } from 'antd';
import './_tab-indicator.scss';

interface Props {
  tabs: Array<object>;
  activeTab: number;
}

const TabIndicator: React.FC<Props> = ({ tabs, activeTab }) => {
  return (
    <Row className="tab-row">
      {tabs.map((tab: any, index: number) => {
        return (
          <div key={index}>
            <span className={tab.key === activeTab ? 'active tab show-on-web' : 'tab show-on-web'}>{tab.title}</span>
            <span className={tab.key === activeTab ? 'active tab show-on-mobile' : 'tab show-on-mobile'}>
              {tab.key === activeTab ? <><span className='number'>{index+1}</span> <span>{tab.title}</span></> : <span className='number'>{index+1}</span>}</span>
            {index < tabs.length - 1 && <RightOutlined style={{ padding: '0 8px' }} />}
          </div>
        );
      })}
    </Row>
  );
};

export default TabIndicator;
